<template>
<div class="crumbs">
  <span class="link" @click="changePath('/mall')">鸿联商城</span>
  <span class="arrow">></span>
  <span class="link" @click="changePath(menu.path)">{{menu.name}} </span>
  <span class="arrow">></span>
  <span class="title">{{title}}</span>
</div>
</template>

<script>
export default {
  name: "VMallCrumbs",
  props:["menu","title"],
  methods:{
    changePath(path){
      this.$router.push(path)
    }
  }
}
</script>


<style scoped lang="scss">
.crumbs{
  padding: 16px 0;
  font-size: 14px;
  line-height: 25px;
  .link{
    color: #8c8c8c;
    cursor: pointer;
    &:hover{
      color: #EA0B06;
    }
  }
  .arrow{
    color: #8c8c8c;
    margin: 0 4px;
  }
  .title{
    color: #262626;
  }
}
</style>
